import * as React from 'react';
const SvgLoading = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 32, height: 32, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M16 4.889C9.862 4.889 4.887 9.863 4.887 16S9.863 27.111 16 27.111 27.11 22.137 27.11 16 22.136 4.889 16 4.889M2.665 16c0-7.364 5.97-13.333 13.333-13.333S29.333 8.637 29.333 16s-5.97 13.333-13.334 13.333S2.666 23.363 2.666 16',
      clipRule: 'evenodd',
      opacity: 0.4,
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M14.889 3.778c0-.614.497-1.111 1.11-1.111A13.333 13.333 0 0 1 29.334 16a1.111 1.111 0 1 1-2.222 0A11.11 11.11 0 0 0 16 4.889a1.11 1.11 0 0 1-1.111-1.111',
      clipRule: 'evenodd',
    }),
  );
export default SvgLoading;
